<template>
  <div class="app-sidebar sidebar-shadow" style="background-color:rgb(242, 242, 242)" @mouseover="menuHover"
       @mouseleave="menuLeave">

    <div class="app-header__logo">
      <div class="logo-src"></div>
      <div class="header__pane ml-auto">
        <div>
          <button type="button" class="hamburger close-sidebar-btn hamburger--elastic"
                  data-class="closed-sidebar">
                                <span class="hamburger-box">
                                    <span class="hamburger-inner"></span>
                                </span>
          </button>
        </div>
      </div>
    </div>
    <div class="app-header__mobile-menu">
      <div>
        <button type="button" class="hamburger hamburger--elastic mobile-toggle-nav">
                            <span class="hamburger-box">
                                <span class="hamburger-inner"></span>
                            </span>
        </button>
      </div>
    </div>

    <div id="linkMenuFixed">

      <a class="text-secondary opacity-6-hover" @click="toggleMenuFixed()">
        <b-icon-pin v-if="getMenuFixed" v-b-tooltip.hover.ds500 title="Desafixar menu"></b-icon-pin>
        <b-icon-pin-angle v-else title="Fixar menu"></b-icon-pin-angle>
      </a>

    </div>

    <vuescroll @onSetBarDrag="correctClickScroll" ref="vs" :ops="ops">
      <div class="app-sidebar__inner">
        <ul class="vertical-nav-menu" style="margin-bottom: 20px;">

          <!--          <li class="app-sidebar__heading">Menu</li>-->
          <t-menu-group v-for="item in menu" :key="item.pageModuleId" @pageRefresh="onPageRefresh()" :groupMenu="item"/>

        </ul>
      </div>
    </vuescroll>
  </div>

</template>
<script>

import TMenuGroup from "@/components/template/menu/t-app-menu-group";
import vuescroll from 'vuescroll';
import myUserService from "@/services/modules/general/MyUser.service";

export default {
  name: "t-menu",
  components: {TMenuGroup, vuescroll},
  data() {
    return {
      vBarDragging: false,
      oldMenuFixed: false,

      ops: {
        bar: {
          showDelay: 500,
          onlyShowBarOnScroll: true,
          keepShow: true,
          background: '#b4b4b4',
          opacity: 0.9,
          hoverStyle: false,
          specifyBorderRadius: false,
          minSize: 0,
          size: '7px',
          disable: false
        }
      },
      /*groupsMenu: [
        {
          id: 1,
          title: "Vendas",
          open: false,
          icone: "pe-7s-graph1",
          itens: [
            {id: 1, descricao: "Orçamentos", link: ""},
            {id: 2, descricao: "Pedidos", link: ""},
            {id: 3, descricao: "Notas Fiscais", link: ""},
            {id: 1000, descricao: "", link: ""}, //Divisor
            {id: 33, descricao: "Clientes", link: "sales-customer"},
            {id: 38, descricao: "Configurações", link: ""},
            {id: 6, descricao: "Relatórios", link: ""},
          ]
        },
        {
          id: 2,
          title: "Produção",
          open: true,
          icone: "pe-7s-science",
          itens: [
            {id: 59, descricao: "Ordens de Produção", link: "production-order"},
            {id: 8, descricao: "Painel Operacional", link: ""},
            {id: 1001, descricao: "", link: ""},
            {id: 48, descricao: "Fluxo de Processos", link: "production-process-flow"},
            {id: 37, descricao: "Configurações", link: "production-settings"},
            {id: 10, descricao: "Relatórios", link: ""},
          ]
        },
        {
          id: 3,
          title: "Compras",
          open: false,
          icone: "pe-7s-notebook",
          itens: [
            {id: 11, descricao: "Pedidos de Compra", link: ""},
            {id: 12, descricao: "Compras Efetivas", link: ""},
            {id: 1002, descricao: "", link: ""},
            {id: 13, descricao: "Fornecedores", link: ""},
            {id: 14, descricao: "Relatórios", link: ""},
          ]
        },
        {
          id: 4,
          title: "Produtos",
          open: true,
          icone: "pe-7s-box2",
          itens: [
            {id: 22, descricao: "Produtos", link: "product-product"},
            {id: 16, descricao: "Estoque", link: ""},
            {id: 1003, descricao: "", link: ""},
            {id: 39, descricao: "Configurações", link: "product-setting"},
          ]
        },
        {
          id: 5,
          title: "Financeiro",
          open: false,
          icone: "pe-7s-piggy",
          itens: [
            {id: 24, descricao: "Receitas", link: ""},
            {id: 25, descricao: "Despesas", link: ""},
            {id: 26, descricao: "Fluxo de Caixa", link: ""},
            {id: 1004, descricao: "", link: ""},
            {id: 27, descricao: "Credores", link: ""},
            {id: 28, descricao: "Planos de Conta", link: ""},
            {id: 29, descricao: "Contas Bancárias", link: ""},
            {id: 30, descricao: "Meios de Pagamento", link: ""},
            {id: 76, descricao: "", link: ""},
            {id: 310, descricao: "Relatórios", link: ""},
          ]
        },
        {
          id: 6,
          title: "Administração",
          open: false,
          icone: "pe-7s-config",
          itens: [
            {id: 32, descricao: "Usuários", link: ""},
            {id: 31, descricao: "Empresas", link: "admin-company"},
            {id: 47, descricao: "Departamentos", link: "admin-department"},
            /!*{id: 33, descricao: "Perfis de Acesso", link: "admin-access-profiles"},*!/

          ]
        }
      ]*/
    }

  },
  props: {
    menu: {
      type: Array,
      required: true
    }
  },
  methods: {

    onPageRefresh() {
      /*Atualizar a página*/
      this.$emit('pageRefresh')
    },

    toggleMenuFixed() {
      myUserService.setPreference("menuFixed", !this.getMenuFixed)
      this.$store.commit("setToggleMenuFixed", null)
    },

    correctClickScroll(vBarDragging) {

      this.vBarDragging = vBarDragging

      if (vBarDragging) {

        this.oldMenuFixed = this.getMenuFixed
        this.$store.commit("setMenuFixedOld", this.oldMenuFixed)
        this.$store.commit("setMenuFixed", vBarDragging)

      } else {
        this.$store.commit("setMenuFixedOld", this.oldMenuFixed)
        this.$store.commit("setMenuFixed", this.oldMenuFixed)
      }

      //this.$refs["vs"].$data.classHooks.vBarDragging

    },
    menuHover() {
      this.$store.commit("setMenuHover", true)
    },
    menuLeave() {
      this.$store.commit("setMenuHover", false)
    }

  },
  computed: {

    getMenuFixed() {
      return this.$store.getters.getMenuFixed
    }

  }
}

</script>

<style>
.closed-sidebar .app-sidebar .menu-hidden-on-closed {
  display: none;
}

.closed-sidebar .app-sidebar:hover .menu-hidden-on-closed {
  display: block;
  margin-left: 20px;
}

.closed-sidebar .container-group-menu.active {
  background-color: #e5edf5;
  padding-top: 9px;
  padding-bottom: 9px;
  margin-bottom: -10px;
  margin-top: 10px;
  position: relative;
}

.app-sidebar:hover .container-group-menu.active {
  background-color: inherit;
}

.closed-sidebar .container-group-menu.active:before {

  position: absolute;
  height: 1px;
  background: #3230d4;
  border-radius: 30px;
  width: 60px;
  left: 10px;
  bottom: 1px;
  content: "";

}


#linkMenuFixed {
  position: absolute;
  right: 5px;
  top: 65px;
  z-index: 5;
  transition: all 200ms ease-in-out;
  visibility: hidden;
}

/*.closed-sidebar .app-sidebar #linkMenuFixed{
  display: none;
}*/

.app-sidebar:hover #linkMenuFixed {
  visibility: visible;
}

/*.app-sidebar:hover #linkMenuFixed{
  visibility: inherit;
}*/

.app-sidebar:hover .container-group-menu.active:before {
  visibility: hidden;
}

.app-sidebar .__rail-is-vertical {
  display: none;
}

.app-sidebar .mouseEnter .__rail-is-vertical {
  display: inherit;
}


</style>
